// extracted by mini-css-extract-plugin
export default {"page":"About_page__1X-r6","row":"About_row__8Cgjl","rowReverse":"About_rowReverse__AK1fD","boxImg":"About_boxImg__V-soP","boxText":"About_boxText__7tjfA","img":"About_img__TB5zm"};